<template>
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M12 2.25 4.5 5.25v6.1c0 4.46 3.17 8.36 7.5 9.65 4.33-1.29 7.5-5.19 7.5-9.65v-6.1L12 2.25Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linejoin="round"
    />
    <rect x="7.6" y="8.6" width="8.8" height="6.8" rx="1" stroke="currentColor" stroke-width="1.3" />
    <path
      d="m8.2 9.7 3.8 2.8 3.8-2.8"
      stroke="currentColor"
      stroke-width="1.3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script setup lang="ts">
/**
 * The envelope-in-a-shield instance mark. Colour comes from the parent (`text-accent`), so the
 * nav and the login screen stay in step with --accent without a prop.
 */
</script>
